import { formatCurrency } from '@/lib/currency';
import type { ProductTileUnitRow } from 'src/lib/product-attributes-pim';

/**
 * Savings vs the compare-at price (list price, or the Omnibus previous price) for the sale badge
 * (tile / PDP supplement). Always rounded down: a 30.9% reduction is announced as -30%
 * (EATWS-472). The epsilon absorbs binary floating-point noise (e.g. 1 - 7.2 / 9 = 0.19999…).
 */
export function computeSaleDiscountPercent(
    isOnSale: boolean,
    listPrice: number | undefined,
    currentPrice: number
): number {
    return isOnSale && listPrice != null && listPrice > 0
        ? Math.max(0, Math.floor(100 * (1 - currentPrice / listPrice) + 1e-9))
        : 0;
}

/** `{amount}{currency} / {pimUm}` from the computed price-per-unit value, else null. */
export function formatPricePerUmLine(unitRow: ProductTileUnitRow, locale: string, currencyCode: string): string | null {
    if (unitRow.pricePerUmValue == null || !unitRow.um) return null;
    const code = currencyCode || 'EUR';
    return `${formatCurrency(unitRow.pricePerUmValue, locale, code)} / ${unitRow.um}`;
}
